import "./index.css";

import React from "react";
import DataComponent from 'Core/components/DataComponent';
import PropTypes from "prop-types";
import {getArray, getString} from 'Core/helpers/data';
import Html from 'Core/components/display/Html';
import ExpertReportInput from 'Components/input/ExpertReportInput';
import Label from 'Core/components/display/Label';

class ExpertReportEditor extends DataComponent {
	constructor(props) {
		super(props, {
			/**
			 * @type {?ExpertReportDataObject}
			 */
			data: null,
			
			/**
			 * GUIID of the section that is editable.
			 * @type {?string}
			 */
			editableSectionGUIID: null,
		}, {
			translationPath: 'ExpertReportEditor',
			domPrefix: 'expert-report-editor',
			enableLoadOnDataPropChange: true,
			optimizedUpdate: true,
			optimizedUpdateIgnoreProps: ['onChange', 'onEnterKey'],
		});
	}
	
	/** @inheritDoc */
	canRender() {
		return (this.getData() !== null);
	}

	render() {
		if (!this.canRender()) return null;
		
		const {className, bounds, mainContentLabel} = this.props;
		/** @type {ExpertReportDataObject} */
		const stateData = this.getData();
		const {editableSectionGUIID} = this.state;
		const isSectionEditable = section => (editableSectionGUIID === section.GUIID);
		const sections = getArray(stateData, 'sections');
		
		return (
			<div id={this.getDomId()} className={`${this.getOption('domPrefix')} ${className}`}>
				<div
					className={`section ${isSectionEditable(stateData) ? 'editable' : ''}`}
					onClick={() => {
						if (isSectionEditable(stateData)) return;
						this.setState({editableSectionGUIID: stateData.GUIID}).then()
					}}
				>
					<div className="section-name">
						<Label content={!!mainContentLabel ? mainContentLabel : this.t('mainContentLabel')} />
					</div>
					<div className="section-content">
						{isSectionEditable(stateData) ?
							<ExpertReportInput
								bounds={bounds}
								value={getString(stateData, 'content')}
								onChange={v => this.handleValueChangeAndUpdate('content', v)}
								onClose={() => this.setState({editableSectionGUIID: null})}
							/>
							:
							<Html
								element="div" 
								elementProps={{className: 'content-preview'}} 
								content={getString(stateData, 'content')} 
							/>
						}
					</div>
				</div>
				
				{sections.map(section =>
					<div 
						key={section.GUIID} 
						className={`section ${isSectionEditable(section) ? 'editable' : ''}`}
						onClick={() => {
							if (isSectionEditable(section)) return;
							this.setState({editableSectionGUIID: section.GUIID}).then()
						}}
					>
						<div className="section-name">
							<Label content={section.name} />
						</div>
						<div className="section-content">
							{isSectionEditable(section) ?
								<ExpertReportInput
									value={getString(section, 'content')}
									bounds={bounds}
									onChange={c => 
										this.updateStateArrayItem('data.sections', {GUIID: section.GUIID}, {content: c})
											.then(() => this.update())
									}
									onClose={() => this.setState({editableSectionGUIID: null})}
								/>
								:
								<Html
									element="div"
									elementProps={{className: 'content-preview'}}	
									content={getString(section, 'content')} 
								/>
							}
						</div>
					</div>
				)}
			</div>
		);
	}
}

/**
 * Define the component's own props that can be passed to it by parent components
 */
ExpertReportEditor.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	bounds: PropTypes.string,
	/** @type {?ExpertReportDataObject} */
	data: PropTypes.object,
	mainContentLabel: PropTypes.string,
	
	onChange: PropTypes.func,
};

/**
 * Define component default values for own props
 */
ExpertReportEditor.defaultProps = {
	id: '',
	className: '',
};

export default ExpertReportEditor;